module.exports = __webpack_public_path__ + "static/media/covid.ace5f0c5.gif";